<template>
    <CreateCutRequest></CreateCutRequest>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const CreateCutRequest = defineAsyncComponent(() =>
    import("../../components/CNC/CreateCutRequest.vue")
);

export default {
    name: "Create_Cut_Request", //The name you are in should not equal the name of the component you are importing.
    components: { CreateCutRequest, AuthLayout },
};
</script>

<style scoped></style>
